'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1653061542-develop/node_modules/axios/lib/cancel/isCancel.js
// module id = 81
// module chunks = 0